<template>
  <DataGetter
    :url="`${apiRoute}/procurement`"
    :params="{
      product: selectedProduct,
      region: selectedRegion,
      flow: procurementTypes,
    }"
    :formatter="fiveYearSum"
    v-slot="{ data }"
    :childElementType="null"
  >
    <ChartLayout
      :title="`Primary policy and market drivers for utility-scale renewable growth, ${selectedRegion}`"
      units="%"
    >
      <Chart v-if="data && data.length > 0" :options="getOptions(data)" />
      <div class="error f-ui-2" v-if="data && data.length === 0">
        Procurement data only available at the individual country level.
      </div>
    </ChartLayout>
  </DataGetter>
</template>

<script>
import { DataGetter } from "@international-energy-agency/vue-ui";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { Chart } from "highcharts-vue";
export default {
  props: {
    apiRoute: {
      type: String,
      default: "https://api.iea.org/renewables",
    },
    selectedProduct: {
      type: String,
      required: true,
    },
    selectedRegion: {
      type: String,
      required: true,
    },
  },
  components: { DataGetter, ChartLayout, Chart },
  data() {
    return {
      procurementTypes: [
        "Corporate Power Purchase agreement",
        "Fixed tariffs and premiums",
        "Green certificates",
        "Auctions and tenders",
        "Unsolicited bilateral contract",
        "Tax credit",
        "Merchant",
        "Utility-owned",
        "Hydrogen projects",
      ],
    };
  },
  methods: {
    fiveYearSum(data) {
      const { procurementTypes } = this;
      return data
        .reduce((byCategory, row) => {
          const existing = byCategory.find((s) => s.name === row.flow);
          if (existing) {
            existing.data = [existing.data[0] + row.value];
          } else {
            byCategory.push({
              name: row.flow,
              data: [row.value],
              colorIndex: procurementTypes.indexOf(row.flow),
            });
          }
          return byCategory;
        }, [])
        .toSorted((a, b) => b.data[0] - a.data[0]);
    },
    getOptions(data) {
      return ChartOptions.buildOptions(
        {
          chart: {
            height: 480,
          },
          series: data,
          legend: {
            enabled: false,
          },
          yAxis: {
            plotLines: [
              { value: 0, className: "highcharts-zero-axis", zIndex: 99 },
              { value: 100, className: "highcharts-zero-axis", zIndex: 99 },
            ],
          },
          xAxis: {
            type: "category",
            categories: ["2023-2028"],
          },
          plotOptions: {
            column: {
              dataLabels: {
                enabled: true,
                format: "{series.name} {point.percentage:.0f}%",
              },
              stacking: "percent",
            },
          },
          tooltip: {
            headerFormat: "",
            pointFormat: "{series.name} <b>{point.percentage:.0f}%</b>",
          },
        },
        "column"
      );
    },
  },
};
</script>

<style scoped>
.error {
  width: 100%;
  height: 520px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>